import React, { useState, useEffect } from 'react'
import { Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'
import { navigate } from '@reach/router'

const UpdateButton = ({ slug }) => {

  const [isLoading, setIsLoading] = useState(false)

  const onClickHandler = () => {
    setIsLoading(true)
  }

  useEffect(() => {
    isLoading && (
      navigate(`/admin/periodos/${slug}`)
      .then(() => setIsLoading(false))
    )      
  }, [isLoading])

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Actualizar Informaci&oacute;n</strong>
        </Tooltip>
      }
    >
      <Button className="mr-1" variant="secondary" onClick={onClickHandler} >
        { isLoading ? <Spinner size="sm" animation="border" variant="light" /> : <i className=" fa fa-edit"></i> }
      </Button>
    </OverlayTrigger>
  )
}

export default UpdateButton